export default "__VITE_ASSET__78851e27__"